"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _default = (0, _react.createContext)({
  superCategory: null,
  category: null,
  isSticky: false,
  updateSearchFilters: function updateSearchFilters() {}
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/search/SearchSelectContext.js
// module id = 376
// module chunks = 209 210 211 212